// Humanized item status translations
export default {
  offer_pending: 'Waiting for a buyer',
  awaiting_buyer: 'Waiting for a buyer',
  awaiting_seller: 'Waiting for the seller',
  ready_to_ship: 'Token ready to ship',
  awaiting_buyer_confirm: 'Waiting for shipping selection',
  ready_to_meet: 'Ready to meetup',
  shipped: 'Shipped',
};
